// Just a const file with an image URL. Nothing to see here.
export const InstantOfferImage = 'https://p1.aprimocdn.net/carmax/e1c7d266-fc2d-4661-a3fa-b3ec00f41387.jpg';